import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  cancelPreviousRequest,
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";
import axios from "axios";

export const studySiteDataEntryServices = {
  //Study 
  getStudySiteEventSchema,
  getStudySiteSubjectList,
  getStudySiteSubjectStatus,
  getStudySiteLarList,
  repeatStudySubjectEvent,
  softDeleteRestoreStudySubjectRepeatEvent,
  getStudySubjectDeletedRepeatEventList,
  getStudySiteEventDataBasedonSchema,
  getStudySiteEventTimePointDataBasedonEvent,
  getStudyFormListBasedonEventSchema,

  // Please remove these API afer implementation
  deleteTimeUserStudySubjectDataEntry,

  //Data Entry
  uploadDocumentData,
  getStudySubjectEventStatus,
  updateTimeUserStudySubjectDataEntry,
  uploadFileSingleRowStudySubjectDataEntry,
  checkEventLevelFormDataEntry,
  addNewStudySubjectDataEntry,
  repeatStudySubjectEventForm,
  getStudyConnectedFormFields,
  studyConnectFormWithFieldOption,
  getStudyConnectedFormList,
  getStudySubjectDataEntry,
  getStudySubjectLogDataEntry,
  softDeleteRestoreStudySubjectLogRecord,
  getStudySubjectDeletedLogRecordList,
  getStudySubjectFormFieldCurrentStatus,
  getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
  getStudySubjectFormFieldReviewHistoryDataEntry,
  getStudySubjectFormFieldQueryHistoryDataEntry,
  getStudySubjectFormFieldQueryNotificationDataEntry,
  getStudySubjectFormFieldQueryNotificationDiscussionDataEntry,
  generateManualQueryStatusStudySubjectFormField,
  generateQueryNotificationStatusStudySubjectFormField,
  queryDiscussionStudySubjectFormField,
  reOpenQueryStudySubjectFormField,
  getStudyDataEntryFieldUpdatedHistoryList,
  getStudySubjectFormFieldQueryDiscussionDataEntry,
  generateManualQueryStudySubjectFormFieldDataEntry,
  unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry,
  signatureStudySubjectFormReviewFieldHistoryDataEntry,
  signatureStudySubjectFormReviewAllFieldDataEntry,
  signatureStudySubjectFormReviewHistoryDataEntry,
  bulkAssignStudySubjectFormReviewHistoryDataEntry,
  bulkSignatureStudySubjectFormReviewHistoryDataEntry,
  getStudySubjectFormReviewDataEntryList,

  //Data Entry
  getStudyBySiteFormDataEntry,
  getStudyBySiteSubjectFormDataEntry,

  //SDV Management
  getStudyFormSDVList,
  assignReviewerStudyFormSDV,
  getStudyBySiteFormSDVHistory,
  getStudyBySiteSubjectFormSDVHistory,
  getStudyFormSiteWiseTotalSDV,
  getStudySitePerformanceSDVSummery,
  getStudyUserActivitySDVSummery,
  getStudyFormSiteWiseTotalFormLevelSDV,

  //Query Management
  getStudyFormBySiteTotalQuery,
  getStudyFormBySiteSubjectTotalQuery,
  getStudyFormFieldQueryHistory,
  getStudyFormFieldQueryOverview,
  getStudyFormSiteWiseTotalQuery,
  getStudyFormSiteWiseTotalFormLevelQuery,
  getStudySitePerformanceQuerySummery,
  getStudyUserActivityQuerySummery,

  //Notification Management
  getStudyFormBySiteSubjectTotalNotification,
  getStudyFormBySiteTotalNotification,
  getStudyFormFieldNotificationHistory,
  getStudyFormFieldNotificationOverview,
  getStudyFormSiteWiseTotalNotification,
  getStudyFormSiteWiseTotalFormLevelNotification,
  getStudySitePerformanceNotificationSummery,
  getStudyUserActivityNotificationSummery,

  getStudySiteSubjectEventFormFieldRandomizationData,
  randomizationStudySiteSubjectEventFormField
};

// Get Study Site Subject Event Form Field Randomization
async function getStudySiteSubjectEventFormFieldRandomizationData(
  status,
  studyId,
  schemaId,
  category,
  mode,
  page,
  length
) {
  let response;
  if (page && length) {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySiteSubjectEventFormFieldRandomizationData/${status}/${studyId}/${schemaId}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${
        config.API_URL_USER_ONBOARDING
      }getStudySiteSubjectEventFormFieldRandomizationData/${status}/${studyId}/${schemaId}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Randomization Study Site Subject Event Form Field
async function randomizationStudySiteSubjectEventFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}randomizationStudySiteSubjectEventFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Event Schema
async function getStudySiteEventSchema(studyId) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteEventSchema/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
// Get Study Subject List
async function getStudySiteSubjectList(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectList/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
// Get Study Subject Status
async function getStudySiteSubjectStatus(studyId, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectStatus/${studyId}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteSubjectStatus/${studyId}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Lar List
async function getStudySiteLarList(studyId, category, mode) {
  let response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySiteLarList/${studyId}/${category}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Site Data based on Schema
async function getStudySiteEventDataBasedonSchema(studyId, siteId, schemaId, subjectId, mode, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySiteEventDataBasedonSchema") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySiteEventDataBasedonSchema/${studyId}/${siteId}/${schemaId}/${subjectId}/${mode}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Site Event Time Point Data based on Event
async function getStudySiteEventTimePointDataBasedonEvent(studyId, siteId, schemaId, eventId, subjectId, repeatType, repeatEventId, mode, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySiteEventTimePointDataBasedonEvent") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySiteEventTimePointDataBasedonEvent/${studyId}/${siteId}/${schemaId}/${eventId}/${subjectId}/${repeatType}/${repeatEventId}/${mode}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Form List Based on Event Schema
async function getStudyFormListBasedonEventSchema(studyId, siteId, subjectId, schemaId, eventId, timePointUniqueId, type, viewType, repeatEventId, repeatTimePointId, mode, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyFormListBasedonEventSchema") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyFormListBasedonEventSchema/${studyId}/${siteId}/${subjectId}/${schemaId}/${eventId}/${timePointUniqueId}/${type}/${viewType}/${repeatEventId}/${repeatTimePointId}/${mode}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}


// Update Subject Data Entry Time and User
async function deleteTimeUserStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteTimeUserStudySubjectDataEntry`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Subject Data Entry Time and User
async function updateTimeUserStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateTimeUserStudySubjectDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Repeat Study Subject Event 
async function repeatStudySubjectEvent(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}repeatStudySubjectEvent`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Study Subject Log Form Record
async function softDeleteRestoreStudySubjectLogRecord(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectLogRecord`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Subject Deleted Log Form Record List
async function getStudySubjectDeletedLogRecordList(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectDeletedLogRecordList`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Soft Delete & Restore Study Subject Repeated Event
async function softDeleteRestoreStudySubjectRepeatEvent(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySubjectRepeatEvent`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Subject Deleted Repeated Event List
async function getStudySubjectDeletedRepeatEventList(studyId, siteId, subjectId, schemaId, mode) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectDeletedRepeatEventList/${studyId}/${siteId}/${subjectId}/${schemaId}/${mode}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Upload Subject Data Entry
async function uploadFileSingleRowStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}uploadFileSingleRowStudySubjectDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Check Event Level Form Data Entry
async function checkEventLevelFormDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}checkEventLevelFormDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Add Subject Data Entry
async function addNewStudySubjectDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySubjectDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Upload File Get Url
async function uploadDocumentData(formData) {
  try {
    const response = await axios.post(
      `${config.API_URL_USER_ONBOARDING}uploadDocumentData`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Upload document failed:", error);
    handleResponse({
      statusCode: 400,
      customMessage: error?.response?.data?.message || "Something went wrong on upload"
    })
  }
}

// Repeat Study Subject Event Form
async function repeatStudySubjectEventForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}repeatStudySubjectEventForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Study Connected Form Fields
async function getStudyConnectedFormFields(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyConnectedFormFields`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Study Connect Form with Field Option
async function studyConnectFormWithFieldOption(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}studyConnectFormWithFieldOption`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Study Connected Conditional Form
async function getStudyConnectedFormList(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyConnectedFormList`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Add Subject Data Entry
async function getStudySubjectDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Add Subject Log Data Entry
async function getStudySubjectLogDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectLogDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectLogDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Form Field Current Status
async function getStudySubjectFormFieldCurrentStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldCurrentStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Subject Form Freeze Unfreeze  History
async function getStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFreezeUnfreezeHistoryDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFreezeUnfreezeHistoryDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Form Field Review  History
async function getStudySubjectFormFieldReviewHistoryDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFieldReviewHistoryDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldReviewHistoryDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Form Field Query History
async function getStudySubjectFormFieldQueryHistoryDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFieldQueryHistoryDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryHistoryDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Form Field Query Notification Discussion
async function getStudySubjectFormFieldQueryNotificationDiscussionDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFieldQueryNotificationDiscussionDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryNotificationDiscussionDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}


// Get Study Subject Form Field Query Notification
async function getStudySubjectFormFieldQueryNotificationDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFieldQueryNotificationDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryNotificationDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Generate Manual Query Status
async function generateManualQueryStatusStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateManualQueryStatusStudySubjectFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Generate Query Nofitication Status
async function generateQueryNotificationStatusStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateQueryNotificationStatusStudySubjectFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Generated Query Discussion
async function queryDiscussionStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}queryDiscussionStudySubjectFormField`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Re-open Query Form Field
async function reOpenQueryStudySubjectFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}reOpenQueryStudySubjectFormField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Data Entry Field Updated History
async function getStudyDataEntryFieldUpdatedHistoryList(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyDataEntryFieldUpdatedHistoryList") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyDataEntryFieldUpdatedHistoryList`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Form Field Query Discussion
async function getStudySubjectFormFieldQueryDiscussionDataEntry(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormFieldQueryDiscussionDataEntry") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormFieldQueryDiscussionDataEntry`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Unfreze Study Subject Form Freeze Unfreeze  History
async function unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Generate Manual Query Study Subject Form Field
async function generateManualQueryStudySubjectFormFieldDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}generateManualQueryStudySubjectFormFieldDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Signature Study Subject Form Field Review  History
async function signatureStudySubjectFormReviewFieldHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewFieldHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Signature Study Subject Form All Field Review
async function signatureStudySubjectFormReviewAllFieldDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewAllFieldDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study by Site Form Data Entry
async function getStudyBySiteFormDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteFormDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study by Site and Subject Form Data Entry
async function getStudyBySiteSubjectFormDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteSubjectFormDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form SDV List
async function getStudyFormSDVList(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSDVList`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Assign Reviewer Study Form SDV
async function assignReviewerStudyFormSDV(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}assignReviewerStudyFormSDV`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site Form SDV History
async function getStudyBySiteFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site and Subject Form SDV History
async function getStudyBySiteSubjectFormSDVHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyBySiteSubjectFormSDVHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Field Query Overview
async function getStudyFormFieldQueryOverview(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyFormFieldQueryOverview") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyFormFieldQueryOverview`
    const response = await fetch(apiURL, {
      ...headersWithAuth("POST", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Form Field Query History
async function getStudyFormFieldQueryHistory(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyFormFieldQueryHistory") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyFormFieldQueryHistory`
    const response = await fetch(apiURL, {
      ...headersWithAuth("POST", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study By Site Total Query
async function getStudyFormBySiteTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}
// Get Study By Site and Subject Total Query
async function getStudyFormBySiteSubjectTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteSubjectTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Query Statistics
async function getStudyFormSiteWiseTotalQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form SDV Statistics
async function getStudyFormSiteWiseTotalSDV(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalSDV`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study SDV Site Performance
async function getStudySitePerformanceSDVSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceSDVSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study User Activity SDV Summery
async function getStudyUserActivitySDVSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivitySDVSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Site Wise Total Form Level SDV
async function getStudyFormSiteWiseTotalFormLevelSDV(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelSDV`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Query Statistics
async function getStudyFormSiteWiseTotalFormLevelQuery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelQuery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Query Site Performance
async function getStudySitePerformanceQuerySummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceQuerySummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Query User Activity
async function getStudyUserActivityQuerySummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivityQuerySummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Field Notification Overview
async function getStudyFormFieldNotificationOverview(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyFormFieldNotificationOverview") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyFormFieldNotificationOverview`
    const response = await fetch(apiURL, {
      ...headersWithAuth("POST", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Form Field Notification History
async function getStudyFormFieldNotificationHistory(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudyFormFieldNotificationHistory") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudyFormFieldNotificationHistory`
    const response = await fetch(apiURL, {
      ...headersWithAuth("POST", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Form Notification Statistics
async function getStudyFormSiteWiseTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site Total Query
async function getStudyFormBySiteTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study By Site and Subject Total Query
async function getStudyFormBySiteSubjectTotalNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormBySiteSubjectTotalNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Form Notification Statistics
async function getStudyFormSiteWiseTotalFormLevelNotification(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyFormSiteWiseTotalFormLevelNotification`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Notification Site Performance
async function getStudySitePerformanceNotificationSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudySitePerformanceNotificationSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Notification User Activity
async function getStudyUserActivityNotificationSummery(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyUserActivityNotificationSummery`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Bulk Signature Study Subject Form Review  History
async function bulkSignatureStudySubjectFormReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}bulkSignatureStudySubjectFormReviewHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Bulk Signature Study Subject Form Review History
async function bulkAssignStudySubjectFormReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}bulkAssignStudySubjectFormReviewHistoryDataEntry`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Signature Study Subject Form Review  History
async function signatureStudySubjectFormReviewHistoryDataEntry(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}signatureStudySubjectFormReviewHistoryDataEntry`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get Study Subject Form Review  History
async function getStudySubjectFormReviewDataEntryList(userData, allowCancel = true) {
  try {
    const signal = allowCancel ? cancelPreviousRequest("getStudySubjectFormReviewDataEntryList") : undefined;
    let apiURL = `${config.API_URL_USER_ONBOARDING}getStudySubjectFormReviewDataEntryList`
    const response = await fetch(apiURL, {
      ...headersWithAuth("PUT", userData, headers),
      ...(signal && { signal })
    });
    const data = await response.json();
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Study Subject Event Status
async function getStudySubjectEventStatus(studyId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectEventStatus/${studyId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySubjectEventStatus/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}